import {
  CREATE_ORGANISASI_SUCCESS,
  RETRIEVE_ORGANISASI_SUCCESS,
  UPDATE_ORGANISASI_SUCCESS,
  DELETE_ORGANISASI_SUCCESS,
} from "../actions/types";

const initialState = [];

function organisasiReducer(organisasis = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_ORGANISASI_SUCCESS:
      return [...organisasis, payload];

    case RETRIEVE_ORGANISASI_SUCCESS:
      return payload;

    case UPDATE_ORGANISASI_SUCCESS:
      return organisasis.map((item) => {
        if (item.uuid === payload.uuid) {
          return { ...item, ...payload };
        }
        return item;
      });

    case DELETE_ORGANISASI_SUCCESS:
      return organisasis.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return organisasis;
  }
}

export default organisasiReducer;
